// The shared chain card description and tag chips (Up Next, next-video block, Pixie picks).
// Utilities only: each element keeps its chain-meta* class first. Landscape, MCP and
// Pixie overrides stay in CSS and win by specificity.
export const CHAIN_META = "tw:mt-[4px] tw:block";
// #777 is 4.48:1 on white; #767676 is the lightest grey that meets WCAG AA (4.5:1).
export const CHAIN_META_DESC =
  "tw:line-clamp-2 tw:text-[11px] tw:[line-height:1.3] tw:text-[#767676]";
export const CHAIN_META_TAGS = "tw:mt-[5px] tw:flex tw:flex-wrap tw:gap-[4px]";
export const CHAIN_META_TAG =
  "tw:inline-block tw:rounded-[10px] tw:bg-light-grey tw:px-[7px] tw:py-[2px] tw:text-[10px] tw:[line-height:1.4] tw:whitespace-nowrap tw:text-[#555]";
